import Vue from 'vue'
import Vuex from 'vuex'
import sites from "./sites/index"
import schedules from "./schedules/index"
import forms from "./forms/index"
import word_paragraphs from "./word_paragraphs/index"
import auth from "./auth/index"


Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        forms: forms,
        sites: sites,
        schedules: schedules,
        word_paragraphs: word_paragraphs,
        auth: auth
    }
})


export default store
